import { wrappedGet } from './urlFuncs';
import {
    USER_TRACKING_URL,
} from "./../inc/constants";
import { API_URL } from './../inc/config';

export const fetchUserTrackingList = (page, limit) =>{
    return wrappedGet(`${API_URL}${USER_TRACKING_URL}?page=${page}&limit=${limit}`, 'GET');
}